module.exports = __webpack_public_path__ + "img/clock.e977a94c.png";